/* VYKA: hide Centre-Stone option chips that have no variant for the selected Diamond Type.
   Targets the custom vyka-pdp option buttons ([data-vyka-opt]/[data-value]). Hides only (no data change).
   Re-runs on chip clicks and DOM/aria updates.
   vyka-hide-opts-locale-v2 (2026-10-12): on Arabic pages the buttons carry the translated values («الألماس المصنّع في
   المختبر») while /products/<handle>.js returns English ones, so nothing matched and EVERY carat chip was hidden.
   The option rows are now found from the English data (names "Diamond Type" / "Centre Stone"), and the values are
   matched against the same product in the page's own language (<locale root>/products/<handle>.js). */
(function () {
  var cache = {};
  function handleFrom() { var p = location.pathname.match(/\/products\/([^/?#]+)/); return p ? p[1] : null; }
  function root() { try { var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; return r.charAt(r.length - 1) === '/' ? r : r + '/'; } catch (e) { return '/'; } }
  function fetchJson(url) { return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }
  function getProduct(handle, cb) {
    var key = root() + handle;
    if (cache[key]) return cb(cache[key]);
    var en = '/products/' + handle + '.js', loc = root() + 'products/' + handle + '.js';
    Promise.all([fetchJson(en), loc === en ? null : fetchJson(loc)]).then(function (r) {
      var out = { en: r[0], loc: r[1] || r[0] }; if (!out.loc) return cb(null);
      if (!out.en) out.en = out.loc;
      cache[key] = out; cb(out);
    });
  }
  function apply() {
    var handle = handleFrom(); if (!handle) return;
    getProduct(handle, function (P) {
      if (!P || !P.en || !P.en.options) return;
      var els = Array.prototype.slice.call(document.querySelectorAll('[data-vyka-opt][data-value]'));
      if (!els.length) return;
      var groups = {};
      els.forEach(function (c) { var k = c.getAttribute('data-vyka-opt'); (groups[k] = groups[k] || []).push(c); });
      var dtOpt = null, csOpt = null;
      P.en.options.forEach(function (o, idx) {
        var nm = (o.name || o).toString();
        if (/diamond\s*type/i.test(nm)) dtOpt = idx;
        if (/cent(?:re|er)\s*stone/i.test(nm)) csOpt = idx;
      });
      if (dtOpt == null || csOpt == null) return;
      var dtEls = groups[String(dtOpt)] || [], csEls = groups[String(csOpt)] || [];
      if (!dtEls.length || !csEls.length) return;
      var selDT = dtEls.filter(function (c) { return c.getAttribute('aria-checked') === 'true' || /is-selected/.test(c.className); })[0];
      var dt = selDT ? selDT.getAttribute('data-value') : null;
      if (!dt) return;
      var valid = {}, any = false;
      (P.loc.variants || []).forEach(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        if (opts[dtOpt] === dt) { var cs = opts[csOpt]; if (cs) { valid[cs] = true; any = true; } }
      });
      if (!any) return;   /* never hide every size: if nothing matched, the data is in a form this script does not understand */
      csEls.forEach(function (c) { c.style.display = valid[c.getAttribute('data-value')] ? '' : 'none'; });
    });
  }
  var t; function schedule() { clearTimeout(t); t = setTimeout(apply, 60); }
  document.addEventListener('DOMContentLoaded', schedule);
  document.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('[data-vyka-opt]')) schedule(); });
  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-checked', 'class'] });
  }
  schedule();
  setTimeout(apply, 600);
  setTimeout(apply, 1500);
})();
